import React, { useEffect, useState } from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Spinner,
  Alert,
  FormGroup,
  Label
} from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { Select } from '../../components/Input';
import SimpleHeader from '../../components/Headers/SimpleHeader';
import client from '../../utils/client';
import SweetAlerts from '../../components/SweetAlerts';

// Vilka ska vara med?? - Patrick
const answers = [];
answers[0] = ['season-open.select'];
answers[1] = ['season-open.answer-1'];
answers[3] = ['season-open.answer-3'];
answers[5] = ['season-open.answer-5'];

// console.log('answers', answers);

const SeasonOpen = () => {
  const { t } = useTranslation();

  const [status, setStatus] = useState(null);
  const [inProgress, setInProgress] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors }
  } = useForm();

  useEffect(() => {
    fetchSeasonData();
  }, []);

  const populateData = (seasonData) => {
    setValue('open', seasonData.open);
    setValue('openText', seasonData.openText);
    setStatus(seasonData);
  };

  const fetchSeasonData = async () => {
    setInProgress(true);
    const { data, error: clubInfoError } = await client('admin-gc/club-info/season-open');

    setInProgress(false);
    if (clubInfoError) {
      setError(clubInfoError.message);
    } else {
      populateData(data);
    }
  };

  const onSubmit = async (formData) => {
    setError(null);
    setSuccess(null);
    setInProgress(true);

    formData.type = 'season';
    const { data, error: saveError } = await client('admin-gc/club-info', { body: formData });

    if (saveError) {
      setError(saveError.message);
    } else {
      populateData(data);
      setSuccess(true);
    }
    setInProgress(false);
  };

  return (
    <>
      <SimpleHeader name={t('club-information.title')} />
      <Container className="mt--6" fluid>
        <Row>
          <Col>
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">{t('season-open.sub-title', 'Öppnat för säsongen')}?</h3>
                </CardHeader>
                <CardBody>
                  {inProgress && <Spinner />}
                  {status && (
                    <Alert color="success" className="mb-3">
                      {`${t('season-open.current-status', 'Nuvarande status')}:
                      ${t(answers[status.open])}`}
                      <br />
                      {status.openReminder
                        ? `${t('season-open.reminder-send', 'Påminnelse skickas')}:
                      ${status.openReminder}`
                        : t('season-open.reminder-no-send', 'En påminnelse skickas inte')}
                    </Alert>
                  )}
                  {error && (
                    <Alert color="danger" className="mb-3">
                      {error}
                    </Alert>
                  )}
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                      <Col>
                        <Row>
                          <Col xs="12" sm="6">
                            <FormGroup>
                              <Label>{t('season-open.open', 'Öppet')}</Label>
                              <Select
                                name="open"
                                register={register}
                                rules={{
                                  required: true
                                }}
                                error={errors.open}
                              >
                                {answers.map((a, idx) => (
                                  <option value={idx} key={a}>
                                    {t(a)}
                                  </option>
                                ))}
                              </Select>
                            </FormGroup>
                          </Col>
                          <Col xs="12" sm="6">
                            <FormGroup>
                              <Label>{t('season-open.reminder', 'Påminnelse')}</Label>
                              <Select
                                name="openReminder"
                                register={register}
                                rules={{
                                  required: true
                                }}
                                error={errors.openReminder}
                              >
                                <option value="">
                                  {t('season-open.remind-me', 'Välj när vi ska påminna er')}
                                </option>
                                <option value="2">
                                  {t('season-open.reminder-2d', 'Påminn mig om två dagar')}
                                </option>
                                <option value="7">
                                  {t('season-open.reminder-1w', 'Påminn mig om 1 vecka')}
                                </option>
                                <option value="14">
                                  {t('season-open.reminder-2w', 'Påminn mig om två veckor')}
                                </option>
                                <option value="0">
                                  {t('season-open.reminder-no', 'Påminn mig inte')}
                                </option>
                              </Select>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12">
                            <FormGroup>
                              <Label>{t('season-open.other-info', 'Övrig information')}</Label>
                              <textarea
                                className="form-control"
                                name="openText"
                                // eslint-disable-next-line react/jsx-props-no-spreading
                                {...register('openText')}
                                // error={errors.openText}
                                // style={{ height: '100px' }}
                              />
                              <span className="small">
                                {t(
                                  'season-open.other-info-note',
                                  'Informationen kommer synas på vår hemsida'
                                )}
                              </span>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="text-align-right">
                            <Button type="submit" color="success" disabled={inProgress}>
                              {inProgress && <Spinner size="sm" />}
                              {t('default.save', 'Spara')}
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
      {success && (
        <SweetAlerts
          title={t('default.save-information-confirmed')}
          onConfirm={() => setSuccess(false)}
        />
      )}
    </>
  );
};

export default SeasonOpen;
